import Layout from "../Partials/Layout";
import {Link, useLocation, useHistory} from "react-router-dom";
import api from '../../shared/utils/auth/Index';
import {useState, useEffect} from "react";
import Loader from "../../shared/components/Loader";
import Pagination from "../../shared/components/Pagination";
import useQueryString from '../../shared/utils/queryString';

const List = () => {

    const { search } = useLocation();

    const history = useHistory();

    const [products, setProducts] = useState(undefined);
    useEffect(() => {
        fetchProducts();
    }, [search]);

    const [filters, setFilters] = useState({});
    const handleFilter = (e) => {
        e.preventDefault();
        let queryString = useQueryString.createQueryStr(search, {
            page: 1,
            ...filters
        });

        history.push({
            search: queryString
        });

        // setProducts(undefined);
    };

    const fetchProducts = () => {
        let url = '/products'+search;
        api.get(url, {}, (res) => {
            let data = res.data;
            setProducts(data);

        }, (err) => {
            alert('error')
        });
    };

    const onDelete = (id) => {
        id = parseInt(id);

        if (window.confirm('آیا مطمئن هستید؟')) {
            setProducts(
                {...products, data: products.data.filter((cat) => cat.id !== id) }
            );

            deleteItem(id);
        }
    }

    const deleteItem = (id) => {
        let url = `/products/${id}`;

        api.delete(url, {}, (res) => {

        }, (err) => {
            alert('Error: Item has not deleted');
        });
    }

    if (products === undefined) return <Layout><Loader/></Layout>;

    return (
        <Layout>
            <div className="font-irs-b">
                <h4 className="d-inline-block ml-4">داشبورد</h4>

                <Link to="/products/create" className="btn btn-outline-secondary">افزودن محصول </Link>
            </div>
            <hr className="my-1 bold-hr"/>

            <form onSubmit={(e) => handleFilter(e)}>
                <div className="row py-2">
                    <div className="col-auto">
                        <input type="text"
                               value={filters.name}
                               onChange={(e) =>
                                   setFilters({...filters, name: e.target.value})}
                               className="form-control"/>
                    </div>
                    <div className="col-auto">
                        <button type="submit" className="btn btn-outline-primary">جستجو</button>
                    </div>
                </div>
            </form>

            <div className="row">
                <div className="col-12">
                    <table className="table table-striped custom-table">
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>نام</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {products.data.map((product, index) => (
                            <tr key={product.id} className={`${!product.active_status ? 'table-danger' : ''}`}>
                                <td>
                                    {index+1}
                                </td>
                                <td>
                                    {product.name}
                                </td>
                                <td>
                                    <div className="action-part">
                                        <Link to={`products/${product.id}/update`} className="btn btn-link">ویرایش</Link>
                                        |
                                        <button className="btn btn-link" type="button"
                                                onClick={() => onDelete(product.id)}
                                                style={{textDecoration: 'none'}}>حذف</button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Pagination meta={products.meta} states={filters}/>
                </div>
            </div>

        </Layout>
    )
}

export default List;
